import React from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import type { DeliveryReadinessBoardKpis } from '@/services/delivery.service';

interface DeliveryReadinessKpiBarProps {
  kpis: DeliveryReadinessBoardKpis;
  loading?: boolean;
}

export const DeliveryReadinessKpiBar: React.FC<DeliveryReadinessKpiBarProps> = ({ kpis, loading }) => (
  <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
    <Col xs={12} sm={8} md={4}>
      <Card size="small" loading={loading}>
        <Statistic title="Ready today" value={kpis.readyToday} />
      </Card>
    </Col>
    <Col xs={12} sm={8} md={4}>
      <Card size="small" loading={loading}>
        <Statistic title="Ready units" value={kpis.readyUnits} />
      </Card>
    </Col>
    <Col xs={12} sm={8} md={4}>
      <Card size="small" loading={loading}>
        <Statistic title="Blocked" value={kpis.blockedCount} valueStyle={{ color: kpis.blockedCount > 0 ? '#cf1322' : undefined }} />
      </Card>
    </Col>
    <Col xs={12} sm={8} md={4}>
      <Card size="small" loading={loading}>
        <Statistic title="Pending dispatch" value={kpis.pendingDispatches} />
      </Card>
    </Col>
    <Col xs={12} sm={8} md={4}>
      <Card size="small" loading={loading}>
        <Statistic title="DN today" value={kpis.todaysDeliveryNotes} />
      </Card>
    </Col>
    <Col xs={12} sm={8} md={4}>
      <Card size="small" loading={loading}>
        <Statistic title="Overdue" value={kpis.overdueDeliveries} valueStyle={{ color: kpis.overdueDeliveries > 0 ? '#d48806' : undefined }} />
      </Card>
    </Col>
  </Row>
);
